<template>
	<div class="w-full">
		<h2 class="border-b text-2xl font-light md:text-4xl">Availability</h2>

		<div class="mt-4">
			<p>Are you legally able to be employed in this country?</p>
			<div class="flex pl-4">
				<div class="flex items-center mr-4">
					<input type="radio" v-model="legally" name="legally" :value="true" id="legally-yes"><label for="legally-yes" class="ml-1">Yes</label>
				</div>
				<div class="flex items-center">
					<input type="radio" v-model="legally" name="legally" :value="false" id="legally-no"><label for="legally-no" class="ml-1">No</label>
				</div>
				<p class="text-xs ml-auto text-red font-bold tracking-wide" v-if="$v.legally.$invalid && $v.$dirty">Required</p>
			</div>
		</div>

		<div class="mt-4">
			<p>Are you available to work nights and weekends?</p>
			<div class="flex pl-4">
				<div class="flex items-center mr-4">
					<input type="radio" v-model="nights" name="nights" :value="true" id="nights-yes"><label for="nights-yes" class="ml-1">Yes</label>
				</div>
				<div class="flex items-center">
					<input type="radio" v-model="nights" name="nights" :value="false" id="nights-no"><label for="nights-no" class="ml-1">No</label>
				</div>
				<p class="text-xs ml-auto text-red font-bold tracking-wide" v-if="$v.nights.$invalid && $v.$dirty">Required</p>
			</div>
		</div>

		<div class="mt-8 flex text-lg justify-between">
			<button @click="submit" :class="{ 'opacity-50 cursor-not-allowed' : $v.$invalid && $v.$dirty }" class="ml-auto font-semibold bg-green-dark text-white py-2 px-4 rounded ml-4 block">Continue</button>
		</div>
	</div>
</template>

<script>
	import { required } from 'vuelidate/lib/validators'

	export default {
		created() {
			this.legally = this.$store.state.form.questionnaire.legally
			this.nights = this.$store.state.form.questionnaire.nights
		},

		data() {
			return {
				submitting: false,
				
				legally: null,
				nights: null,
			}
		},

		validations: {
			legally: { required },
			nights: { required },
		},

		methods: {
			submit() {
				if (this.$v.$invalid || this.submitting) {
					this.$v.$touch()
					return
				}

				this.submitting = true

				this.$store.commit('setQuestionnaire', {
					legally: this.legally,
					nights: this.nights,
				})

				this.$router.push('/experience')
			}
		},
	}
</script>
